module.exports = __webpack_public_path__ + "static/media/football-player.58424cda.png";